import React from "react";
import PropTypes from "prop-types";
import ReactMarkdown from "react-markdown";

export default function MarkdownContent({ content, map, ...args }) {
	return (
		<ReactMarkdown
			components={map}
			{...args}
		>
			{content}
		</ReactMarkdown>
	);
}

MarkdownContent.propTypes = {
	content: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.arrayOf(PropTypes.objectOf(PropTypes.string))
	]),
	map: PropTypes.objectOf(PropTypes.elementType)
};
